// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mSc-1","newExpiryDate":"styles_newExpiryDate__1vWIF","footer":"styles_footer__2Sh8h"};